module.exports = __webpack_public_path__ + "static/bg2-981803c7166074134eec3a0970106c74.jpg";